__turbopack_context__.v({
  "center": "receipt-module-scss-module__mgQnUW__center",
  "definition": "receipt-module-scss-module__mgQnUW__definition",
  "definition-center": "receipt-module-scss-module__mgQnUW__definition-center",
  "definition-space-between": "receipt-module-scss-module__mgQnUW__definition-space-between",
  "receipt": "receipt-module-scss-module__mgQnUW__receipt",
  "row": "receipt-module-scss-module__mgQnUW__row",
  "skeleton": "receipt-module-scss-module__mgQnUW__skeleton",
  "space-between": "receipt-module-scss-module__mgQnUW__space-between",
  "term": "receipt-module-scss-module__mgQnUW__term",
  "term-center": "receipt-module-scss-module__mgQnUW__term-center",
  "term-small": "receipt-module-scss-module__mgQnUW__term-small",
  "term-space-between": "receipt-module-scss-module__mgQnUW__term-space-between",
});
